<h2 data-testid="report-client-name" [class.client-name-super]="super">{{clientNameFull}}</h2>

<div class="section-container">
  <div class="summary">
    <div class="info">
      @if (!loading) {
      <p data-testid="report-started-count" class="stat">{{userCount}}</p>
      }
      @if (loading) {
      <div class="stat-skeleton skeleton-bar dark"></div>
      }
      <p>STARTED</p>
    </div>
    <div class="info">
      @if (!loading) {
      <p data-testid="report-completed-count" class="stat">{{completedCount}} ({{totals.complete}})</p>
      }
      @if (loading) {
      <div class="stat-skeleton skeleton-bar dark" style="width: 120px;"></div>
      }
      <p>COMPLETED</p>
    </div>

    <div data-testid="report-download" class="info clickable green" (click)="downloadReport()">
      <p class="stat">
        <img src="/assets/img/download.svg" alt="Download report icon" />
      </p>
      <p class="download-label">USER REPORT</p>
    </div>

    <div data-testid="report-open-action-report" class="info clickable green" (click)="openActionReport()">
      <p class="stat">
        <img src="/assets/img/check-list-icon.svg" alt="Open action Reports" />
      </p>
      <p class="download-label">ACTION REPORT</p>
    </div>

    <div class="spacer">

    </div>

    <div data-testid="report-resources" class="info clickable" (click)="openWindow('resources.html')">
      <div class="stat2">
        <img src="/assets/img/book.svg" alt="Resources" />
      </div>
      <p class="download-label">RESOURCES</p>

    </div>

    <div data-testid="report-help" class="info clickable" (click)="openWindow('faqs.html')">
      <div class="stat2">
        <img src="/assets/img/help.svg" alt="Help" />
      </div>
      <p class="download-label">HELP</p>

    </div>
  </div>
</div>


@if (!super) {
<div class="section-container">
  <h1>Training versions</h1>
  <app-preview-training></app-preview-training>
</div>
}

<div class="section-container">

  <div class="filter-container">
    <h1 class="activity-title">User activity</h1>
    <input data-testid="report-search" class="filter-input" placeholder="Search" type="text" (keyup)="filter($event)" />
    <a [hidden]="true" href="#" style="margin-left:20px;" #hiddenDownloadReport></a>
    @if (clientId == 0 ) {
    <select data-testid="report-type-filter" class="type-selector" (change)="selectTypeFilter($event)">
      <option value="">Select type</option>
      <option>EDUCATION</option>
      <option>FINANCE</option>
      <option>LAW</option>
      <option>OTHER</option>
    </select>
    }

    <!-- select box with academicYears as options -->
    <select data-testid="report-year-filter" class="type-selector" (change)="selectAcademicYear($event)">
      <option value="">Select academic year</option>
      @for (year of academicYears; track year) {
      <option [value]="year.formatted_year">{{year.formatted_year}}</option>
      }
    </select>

    @if (clientId != 0 ) {
    <select data-testid="report-code-filter" class="type-selector" (change)="selectCode($event)">
      <option value="">Select code</option>
      @for (code of codes; track code) {
      <option [value]="code.code">{{code.code}} - {{code.description}}</option>
      }
    </select>
    }


  </div>


  <div class="table-container">
    <mat-table #table [dataSource]="loading ? [] : dataSource" matSort matSortActive="registered_date"
      matSortDirection="desc" (matSortChange)="sortData($event)">

      @for (column of columnNames; track column) {
      <ng-container matColumnDef="{{ column.id }}">
        <mat-header-cell *matHeaderCellDef mat-sort-header [attr.data-testid]="'report-sort-' + column.id">
          {{ column.value }}</mat-header-cell>
        <mat-cell *matCellDef="let element" [attr.data-testid]="'report-cell-' + column.id" [ngClass]="{'completed-yes': element.complete === 'yes'}">
          {{ element[column.id] }}</mat-cell>
      </ng-container>
      }


      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row data-testid="report-row" *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>

    @if (loading) {
    <div class="skeleton-container">
      @for (row of skeletonRows; track $index) {
      <div class="skeleton-row-flex">
        @for (weight of row; track $index) {
        <div class="skeleton-bar dark" [style.flex-grow]="weight"></div>
        }
      </div>
      }
    </div>
    }

    @if (!loading) {
    <div class="mat-row footer-row special-padding">
      @if (clientId == 0 ) {
      <div class="mat-cell footer-cell mat-column-client_name">-</div>
      }
      @if (clientId == 0 ) {
      <div class="mat-cell footer-cell mat-column-kind">-</div>
      }
      <div class="mat-cell footer-cell mat-column-code">-</div>
      <div class="mat-cell footer-cell mat-column-description">-</div>
      <div class="mat-cell footer-cell mat-column-email">-</div>
      <div class="mat-cell footer-cell mat-column-registered_date">-</div>
      <div class="mat-cell footer-cell mat-column-completed_on">-</div>
      <div class="mat-cell footer-cell mat-column-time_spent_minutes">-</div>
      <div data-testid="report-total-complete" class="mat-cell footer-cell mat-column-complete">{{totals.complete}}</div>
    </div>
    }
    <mat-paginator data-testid="report-paginator" [length]="this.userCount" pageSize="10" [hidePageSize]="true" (page)="onPaginateChange($event)"
      showFirstLastButtons></mat-paginator>

  </div>
</div>